/* eslint-disable */

import axios from "axios";

const endpoint = 'SuperSuppliers';

export default {
    async getFromCurrentUser() {
        const response = await axios.get(`${endpoint}/currentUser`);
        return response.data;
    },
};
